import {
  MrSearchConfig,
  MrSearchFacetsConfig,
  MrSearchLayoutInput,
} from '@net7/boilerplate-muruca';

const facets = {
  sections: [
    // {
    //   id: 'section-query',
    //   inputs: [
    //     {
    //       id: 'query',
    //       type: 'text',
    //       queryParam: true,
    //       delay: 500,
    //       schema: {
    //         valueType: 'string',
    //       },
    //       data: {
    //         id: 'query',
    //         placeholder: 'search#placeholder_query',
    //         icon: 'n7-icon-search',
    //         inputPayload: 'search-input',
    //         enterPayload: 'search-enter',
    //         iconPayload: 'search-icon',
    //       },
    //     },
    //   ],
    // },
    {
      id: 'section-query',
      inputs: [
        {
          id: 'query',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query',
            placeholder: 'search#placeholder_localita',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    {
      id: 'section-query-edizione',
      inputs: [
        {
          id: 'query-edizione',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query-edizione',
            placeholder: 'search#placeholder_query-edizione',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    {
      id: 'section-geolocal',
      header: {
        id: 'header-geolocal',
        data: {
          text: 'search#header_map',
          additionalText: null
        }
      },
      inputs: [{
        id: 'geolocal',
        type: 'map',
        limit: 500,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: false,
        },
        initialize: true,
        libOptions: {
          center: [42.00, 12.50],
          zoom: 6,
          minZoom: 2,
          // maxZoom: 8,
          iconSize: [13, 20],
          maxClusterRadius: 10,
          disableClusteringAtZoom: 8,
          hideUnavailablePin: true,
          layerUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
      }],
    },
    // {
    //   id: 'section-years',
    //   header: {
    //     id: 'header-years',
    //     data: {
    //       text: 'search#header_years',
    //       additionalText: null
    //     }
    //   },
    //   inputs: [{
    //     id: 'years',
    //     type: 'histogram',
    //     limit: 500,
    //     queryParam: true,
    //     schema: {
    //       valueType: 'string',
    //       multiple: false,
    //     }
    //   }],
    // },
    {
      id: 'section-centuries',
      header: {
        id: 'header-centuries',
        data: {
          text: 'search#header_centuries',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'centuries',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    },
    {
      id: 'section-rilevamento',
      header: {
        id: 'header-rilevamento',
        data: {
          text: 'search#header_rilevamento',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'rilevamento',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
    {
      id: 'section-materiale',
      header: {
        id: 'header-materiale',
        data: {
          text: 'search#header_materiale',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'materiale',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
    {
      id: 'section-tipologia',
      header: {
        id: 'header-tipologia',
        data: {
          text: 'search#header_tipologia',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'tipologia',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
    {
      id: 'section-tecnica',
      header: {
        id: 'header-tecnica',
        data: {
          text: 'search#header_tecnica',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'tecnica',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
    {
      id: 'section-sistema',
      header: {
        id: 'header-sistema',
        data: {
          text: 'search#header_sistema',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'sistema',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
    {
      id: 'section-soggettario',
      header: {
        id: 'header-soggettario',
        data: {
          text: 'search#header_soggettario',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'soggettario',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
    {
      id: 'section-lingua',
      header: {
        id: 'header-lingua',
        data: {
          text: 'search#header_lingua',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'lingua',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
    {
      id: 'section-mista',
      header: {
        id: 'header-mista',
        data: {
          text: 'search#header_mista',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        },
      },
      inputs: [
        {
          id: 'mista',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-conservazione',
      header: {
        id: 'header-conservazione',
        data: {
          text: 'search#header_conservazione',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'conservazione',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
    {
      id: 'section-autore',
      header: {
        id: 'header-autore',
        data: {
          text: 'search#header_autore',
          additionalText: null,
          iconRight: 'n7-icon-angle-down',
        }
      },
      inputs: [{
        id: 'autore',
        type: 'link',
        limit: 50,
        queryParam: true,
        schema: {
          valueType: 'string',
          multiple: true
        },
        data: {
          links: []
        }
      }]
    }, 
  ],
  classes: 'facets-wrapper',
} as MrSearchFacetsConfig;

const layoutInputs = ['page', 'limit', 'sort'].map((id) => ({
  id,
  queryParam: true,
  schema: {
    valueType: id === 'sort' ? 'string' : 'number',
  },
})) as MrSearchLayoutInput[];

const request = {
  results: {
    id: 'search',
    delay: 500,
  },
  facets: {
    id: 'facets',
  },
  provider: 'rest',
  delay: 500,
};

export default { request, facets, layoutInputs } as MrSearchConfig;
